module.exports = __webpack_public_path__ + "img/image9.978ce3db.jpg";